module.exports = "/images/media-call-nav.svg?426a1dd98c028a5082c442a8f3863a26";